import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

const StyledToolbar = styled.div`
  height: inherit;
  position: relative;
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

const HeaderToolbar = ({ className, ...rest }: { className?: string; children?: React.ReactNode }) => {
  return <StyledToolbar className={classNames(className, 'toolbar')} {...rest} />;
};

export default HeaderToolbar;
